import Vue from 'vue'
import { platformFromQuery, isWebAppQuery } from './web-auth-rules'

const key = 'eelink.web.session'
const initialQuery = {}
const params = new URLSearchParams(window.location.search)
for (const name of ['os', 'webApp']) if (params.has(name)) initialQuery[name] = params.getAll(name).length === 1 ? params.get(name) : params.getAll(name)
function restoredSession() {
  try {
    const value = JSON.parse(sessionStorage.getItem(key))
    return value && typeof value.username === 'string' && [1, 2].includes(value.level) ? value : null
  } catch (_) { return null }
}
export const webAuth = Vue.observable({
  browser: isWebAppQuery(initialQuery), platform: platformFromQuery(initialQuery), session: restoredSession(), expired: false, revision: 0
})

export function saveWebSession(value) {
  webAuth.session = value
  webAuth.expired = false
  webAuth.revision++
  try {
    if (value) sessionStorage.setItem(key, JSON.stringify(value))
    else sessionStorage.removeItem(key)
  } catch (_) { /* Private browsing may disallow storage; the in-memory session still works. */ }
}

export function expireSession(revision) {
  if (revision !== webAuth.revision || webAuth.expired) return
  if (!webAuth.browser) return
  saveWebSession(null)
  webAuth.expired = true
  window.dispatchEvent(new Event('eelink-web-session-expired'))
}
